import axios from 'axios';

const API = axios.create({
  baseURL: '/api',
});

// Automatsko dodavanje tokena ako postoji
API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');

  // Izbegni dodavanje tokena za rute koje su javne
  if (!(req.url.includes('/visits/') && req.url.includes('/confirm'))) {
    if (token) {
      req.headers.Authorization = token;
    }
  }

  return req;
});

// Automatsko izlogovanje ako token istekne
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Login s geolokacijom
export const login = (email, password, latitude, longitude) =>
  API.post('/login', {
    email,
    password,
    latitude,
    longitude,
  });

export const getStudents = (token) =>
  API.get('/students', {
    headers: {
      Authorization: token,
    },
  });

// Dohvatanje učitelja (admin)
export const getTeachers = () => API.get('/teachers');

// Kreiranje posete
export const createVisit = (student_id, scheduled_at, notes) =>
  API.post('/visits', { student_id, scheduled_at, notes });

export const sendGeolocation = (token, lat, lon, type = 'other') =>
  API.post('/geolocation', { lat, lon, type }, {
    headers: { Authorization: token }
  });
  
export const reverseGeocode = (token, lat, lon) =>
  API.post('/reverse-geocode', { lat, lon }, {
    headers: { Authorization: token }
  });

export const getTaxonomy = (active = 1) =>
  API.get('/taxonomy', { params: { active } });

  export const saveTeacherTaxonomy = (teacherId, payload) =>
    API.put(`/teachers/${teacherId}/taxonomy`, payload);

  export const saveStudentTaxonomy = (studentId, payload) =>
    API.put(`/students/${studentId}/taxonomy`, payload);

  export const matchTeachers = (studentId) =>
    API.get('/match/teachers', { params: { student_id: studentId } });
	
export default API;